import {
  RelationContextType,
  RelationOption,
} from '@components/EntityDrawers/drawers/Relationship/constants/types';
import { RelationshipFormValues } from '@components/EntityDrawers/drawers/Relationship/form';
import { WeightTypes } from '@constants/entities/relationship';
import { EdgeDTO } from '@store/services/nodes/types';
import { cutNumberPeriods } from '@utils/helpers';

export type RelationshipFormSyncOpts = {
  isLastANDAuto: boolean;
  contextType: RelationContextType | null;
  parentOptions: RelationOption[];
};

/** Maps API relation DTO to RHF values (same rules as useFormReset). */
export function edgeDtoToRelationshipFormValues(
  dto: EdgeDTO,
  opts: RelationshipFormSyncOpts,
  /**
   * Kept when the dto carries no `description`, so a re-sync can't wipe text the user still sees.
   */
  descriptionFallback?: string | null,
): Omit<RelationshipFormValues, 'maxWeight'> {
  const {
    type,
    dependency,
    description,
    weight,
    weight_type,
    valid_status,
    meta_data,
  } = dto;

  const resolvedDescription =
    description === undefined || description === null
      ? descriptionFallback ?? ''
      : description;

  return {
    type,
    dependency,
    valid_status,
    description: resolvedDescription,
    weight: cutNumberPeriods(weight),
    weight_manual: weight_type === WeightTypes.Manual,
    isLastANDAuto: opts.isLastANDAuto,
    context: Object.fromEntries(
      opts.parentOptions.map(({ id }) => {
        const savedValue = meta_data?.controls?.[id];

        return [
          id,
          savedValue?.length ||
          opts.contextType === RelationContextType.FunctionTechnology
            ? savedValue
            : null,
        ];
      }),
    ),
  };
}
